// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-scroll-to-top[data-v-8fbca180]{position:fixed;top:20%;right:30px;z-index:99;opacity:0;-webkit-transition:all .5s ease;transition:all .5s ease}@media(max-width:768px){.btn-scroll-to-top[data-v-8fbca180]{right:10px;bottom:8%}}.btn-scroll-to-top.show[data-v-8fbca180]{opacity:.6}.btn-scroll-to-top.show[data-v-8fbca180]:hover{opacity:1}.ps-customizer-area[data-v-8fbca180]{max-height:75vh}", ""]);
// Exports
module.exports = exports;
